import React from 'react'
import LocaleWrapperContainer from './LocaleWrapperContainer'

const LocaleWrapper = props => (
  <LocaleWrapperContainer data-test="component-locale-wrapper-container" {...props} />
)
export default LocaleWrapper
